module.exports = __webpack_public_path__ + "img/Кабинет врача Горбатенко А.И..f83a2ce7.jpg";